<assignee-family-person-icon
  type="Assignee"
  [person]="assignee"
  [link]="assigneeLink"
  [isAssignmentEncrypted]="isAssignmentEncrypted"
  class="icon"
></assignee-family-person-icon>

@if (assignee.party.partner) {
<assignee-family-person-icon
  type="Partner"
  [person]="assignee.party.partner"
  [link]="familyLink"
  [isAssignmentEncrypted]="isAssignmentEncrypted"
  class="icon"
></assignee-family-person-icon>
} @for (person of assignee.party.other; track person) {
<assignee-family-person-icon
  type="Other"
  [person]="person"
  [link]="familyLink"
  [isAssignmentEncrypted]="isAssignmentEncrypted"
  class="icon"
></assignee-family-person-icon>
} @for (person of assignee.party.children; track person) {
<assignee-family-person-icon
  type="Child"
  [person]="person"
  [link]="familyLink"
  [isAssignmentEncrypted]="isAssignmentEncrypted"
  class="icon"
></assignee-family-person-icon>
} @for (pet of assignee.party.pets; track pet) {
<assignee-family-pet-icon
  [pet]="pet"
  [link]="petsLink"
  class="icon"
></assignee-family-pet-icon>
}
